import color from './img/Angularjs.gif';
import fig2 from './img/fig2.gif';
import responsive from './img/responsive.gif';
import dev from './img/dev.gif';

export const products = [
	{
		id: 1,
		img: color,
		link: 'https://reliable-croquembouche-f6ef21.netlify.app/',
	},
	{
		id: 2,
		img: fig2,
		link: 'https://react-projects-19-stock-photos.netlify.app/',
	},
	{
		id: 3,
		img: responsive,
		link: 'https://dazzling-nasturtium-e2bffe.netlify.app/',
	},
	{
		id: 4,
		img: dev,
		link: 'https://sankalp-shandilya-drinks.netlify.app/',
	},
];
